import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ApiService } from './api.service';

export interface ApiResponse<T> {
    success: boolean;
    message: string | null;
    data: T;
    errorCode: string | null;
}

export interface DashboardOverview {
    activeConversations: number;
    completedToday: number;
    handoff: number;
    avgResponseTime: number;
}

export interface WorkflowStat {
    workflowId: string;
    totalConversations: number;
    stepsCompleted: number;
    handoff: number;
    failures: number;
    completionRate: number | null;
    handoffRate: number | null;
    failureRate: number | null;
    avgResponseTime: number | null;
}

export interface FunnelStep {
    stepKey: string;
    entered: number;
    completed: number;
}

export interface AiMetrics {
    intentDetected: number;
    intentFallback: number;
    validationFailures: number;
    fallbackRate: number;
}

@Injectable({ providedIn: 'root' })
export class DashboardService {
    constructor(private api: ApiService) {}

    getOverview(days: number): Observable<DashboardOverview> {
        return this.api.get<ApiResponse<DashboardOverview>>('/api/dashboard/overview', { days })
            .pipe(map((res) => res.data));
    }

    getWorkflowStats(days: number): Observable<WorkflowStat[]> {
        return this.api.get<ApiResponse<WorkflowStat[]>>('/api/dashboard/workflows', { days })
            .pipe(map((res) => res.data ?? []));
    }

    getFunnel(workflowId: string): Observable<FunnelStep[]> {
        return this.api.get<ApiResponse<FunnelStep[]>>('/api/dashboard/funnel', { workflowId })
            .pipe(map((res) => res.data ?? []));
    }

    getAiMetrics(days: number): Observable<AiMetrics> {
        return this.api.get<ApiResponse<AiMetrics>>('/api/dashboard/ai-metrics', { days })
            .pipe(map((res) => res.data));
    }
}
